<!--
    描述：新增、编辑人员弹框等
    时间：2020-04-23
    Created by zwh
-->
<template>
    <div class="">
        <el-form :model="objectForm" :rules="formRules" ref="objectForm" label-width="100px">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="所属菜单" prop="menuName" :show-message="false">
                        <el-input v-model="objectForm.menuName" disabled autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="按钮名称" prop="btnName" :show-message="false">
                        <el-input v-model="objectForm.btnName" autocomplete="off" :disabled="isDisabled"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="别名" prop="alias" :show-message="false">
                        <el-input v-model="objectForm.alias"
                                  :disabled="isDisabled"
                                  autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="排序" prop="sortNum" :show-message="false">
                        <el-input type="number" v-model="objectForm.sortNum" autocomplete="off" :disabled="isDisabled"
                                  :show-message="false"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
    import {saveOrUpdate,getInfoById} from '@/api/modules/menuBtn.js'
    export default {
        props : {
            mode: {
                type: String,
                default: 'add'
            },
            transObj: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        data() {
            return {
                objectForm: {
                    id : '',
                    menuId : '',
                    menuName : '',
                    btnName: '',
                    alias: '',
                    sortNum : '',
                },
                formRules: {
                    menuName: [{required: true, message: '请输入...', trigger: 'blur'}],
                    btnName: [{required: true, message: '请输入...', trigger: 'blur'}],
                    alias: [{required: true, message: '请输入...', trigger: 'blur'}],
                    sortNum: [{required: true, message: '请输入...', trigger: 'blur'}],
                },
            }
        },
        methods: {
            //点击确定按钮事件
            doSave() {
                let that = this
                this.$refs['objectForm'].validate((valid) => {
                    if (valid) {
                        let param = this.objectForm;
                        saveOrUpdate(param).then(res => {
                            if(res.operationCode==1){
                                that.$message({message: '保存成功',type: 'success'});
                                //刷新菜单信息
                                that.$emit('handle-success')
                            }
                        });
                    } else {
                        return false;
                    }
                });
            },
            // 查看、编辑初始渲染数据
            getObjectById() {
                let that = this
                let param = { id : this.transObj.id }
                getInfoById(param).then(res => {
                    if(res.operationCode==1){
                        res.data != null && res.data != '' ? this.objectForm = res.data : ''
                    }
                });
            },
        },
        created() {
            if(this.mode=='add'){
                this.objectForm.menuId = this.transObj.menuId
                this.objectForm.menuName = this.transObj.menuName
            }
            if (this.mode !== 'add') this.getObjectById()
        },
        computed: {
            // 是否可编辑
            isDisabled() {
                return this.mode === 'view' ? true : false
            }
        }
    }
</script>

<style scoped lang="less">
</style>
